var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right-to-left",attrs:{"id":"app"}},[_vm._m(0),_c('router-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-screen"},[_c('div',{staticClass:"spinner"},[_c('div',{staticClass:"bounce1"}),_c('div',{staticClass:"bounce2"}),_c('div',{staticClass:"bounce3"})]),_c('strong',{staticClass:"mt-3"},[_vm._v("در حال بارگذاری")])])
}]

export { render, staticRenderFns }